export type ObjectiveKey = 'cd_0deg' | 'cd_4deg' | 'delta_cd_4deg' | 'cl_0deg';

export type ObjectivePresetId = 'cd_0deg' | 'cd_0deg-cd_4deg' | 'cd_0deg-delta_cd_4deg' | 'cd_0deg-cl_0deg';

export interface ObjectiveMeta {
  key: ObjectiveKey;
  label: string;
  color: string;
}

export interface ObjectivePreset {
  id: ObjectivePresetId;
  label: string;
  objectives: ObjectiveMeta[];
}

export const OBJECTIVE_KEYS: ObjectiveKey[] = [
  'cd_0deg',
  'cd_4deg',
  'delta_cd_4deg',
  'cl_0deg',
];

export const OBJECTIVE_PRESETS: Record<ObjectivePresetId, ObjectivePreset> = {
  'cd_0deg': {
    id: 'cd_0deg',
    label: '0deg only',
    objectives: [{ key: 'cd_0deg', label: '0°', color: '#00c853' }],
  },
  'cd_0deg-cd_4deg': {
    id: 'cd_0deg-cd_4deg',
    label: '4deg & 0deg',
    objectives: [
      { key: 'cd_0deg', label: '0°', color: '#00c853' },
      { key: 'cd_4deg', label: '4°', color: '#ff9900' },
    ],
  },
  'cd_0deg-delta_cd_4deg': {
    id: 'cd_0deg-delta_cd_4deg',
    label: 'Delta & 0deg',
    objectives: [
      { key: 'cd_0deg', label: '0°', color: '#1976d2' },
      { key: 'delta_cd_4deg', label: 'Δ', color: '#8e24aa' },
    ],
  },
  'cd_0deg-cl_0deg': {
    id: 'cd_0deg-cl_0deg',
    label: 'Cd & Cl',
    objectives: [
      { key: 'cd_0deg', label: 'Cd', color: '#e91e63' },
      { key: 'cl_0deg', label: 'Cl', color: '#3f51b5' },
    ],
  },
};

const sortedKeySignature = (record: Record<string, unknown>) =>
  Object.keys(record || {})
    .filter((key): key is ObjectiveKey => OBJECTIVE_KEYS.includes(key as ObjectiveKey))
    .sort()
    .join('|');

export const determinePresetId = (
  record: Record<string, unknown>
): ObjectivePresetId => {
  switch (sortedKeySignature(record)) {
    case 'cd_0deg':
      return 'cd_0deg';
    case 'cd_0deg|cd_4deg':
      return 'cd_0deg-cd_4deg';
    case 'cd_0deg|delta_cd_4deg':
      return 'cd_0deg-delta_cd_4deg';
    case 'cd_0deg|cl_0deg':
      return 'cd_0deg-cl_0deg';
    default:
      return 'cd_0deg';
  }
};
